import { ComponentProps } from 'react';

import { Alert, Modal, ModalBody, ModalFooter, ModalHeader } from '@growtherapy/sprout-ui';

import { NewSessionConfirmationVariation } from '../state';

type StartNewSessionConfirmationModalProps = Pick<ComponentProps<typeof Modal>, 'onClose' | 'isOpen'> & {
  onConfirm: () => void;
  loading?: boolean;
  visitorName?: string;
  variation?: NewSessionConfirmationVariation;
};

export function StartNewSessionConfirmationModal({
  loading,
  onClose,
  onConfirm,
  visitorName,
  variation,
  ...props
}: StartNewSessionConfirmationModalProps) {
  return (
    <Modal {...{ onClose, ...props }}>
      <ModalHeader>
        <span className='fs-exclude' data-dd-privacy='mask'>
          Start a new session with {visitorName}?
        </span>
      </ModalHeader>
      <ModalBody>
        {variation === 'incompatible' && (
          <Alert className='mb-4' use='info' headingAs='h3'>
            This client is using an incompatible application version and cannot be admitted to the current session.
          </Alert>
        )}
        <span className='fs-exclude' data-dd-privacy='mask'>
          This will end your current session and create a new session with {visitorName}.
        </span>
      </ModalBody>
      <ModalFooter
        actions={[
          {
            key: 'cancel',
            use: 'secondary',
            onClick: onClose,
            actionContent: 'Cancel',
          },
          {
            key: 'confirm-new-session',
            use: 'primary',
            onClick: onConfirm,
            loading,
            actionContent: 'Yes, start new session',
          },
        ]}
      />
    </Modal>
  );
}
